//#region package/mathtools/provides.ts
var macros = {
	mathtoolsset: {
		signature: "m",
		renderInfo: {
			breakAround: true,
			pgfkeysArgs: true
		}
	},
	mathllap: { signature: "o m" },
	mathrlap: { signature: "o m" },
	mathclap: { signature: "o m" },
	clap: { signature: "m" },
	mathmbox: { signature: "m" },
	mathmakebox: { signature: "o o m" },
	cramped: { signature: "o m" },
	crampedllap: { signature: "o m" },
	crampedrlap: { signature: "o m" },
	crampedclap: { signature: "o m" },
	crampedsubstack: { signature: "o m" },
	smashoperator: { signature: "o m" },
	newtagform: { signature: "m o m m" },
	renewtagform: { signature: "m o m m" },
	usetagform: { signature: "m" },
	xleftrightarrow: { signature: "o m" },
	xLeftarrow: { signature: "o m" },
	xhookleftarrow: { signature: "o m" },
	xmapsto: { signature: "o m" },
	xRightarrow: { signature: "o m" },
	xLeftrightarrow: { signature: "o m" },
	xhookrightarrow: { signature: "o m" },
	underbracket: { signature: "o o m" },
	overbracket: { signature: "o o m" },
	underbrace: { signature: "m" },
	overbrace: { signature: "m" },
	shoveleft: { signature: "o m" },
	shoveright: { signature: "o m" },
	ArrowBetweenLines: { signature: "s o" },
	vdotswithin: { signature: "m" },
	shortdotswithin: { signature: "s m" },
	DeclarePairedDelimiter: {
		signature: "m m m",
		renderInfo: { breakAround: true }
	},
	DeclarePairedDelimiterX: {
		signature: "m o m m m",
		renderInfo: { breakAround: true }
	},
	DeclarePairedDelimiterXPP: {
		signature: "m o m m m m m",
		renderInfo: { breakAround: true }
	},
	prescript: { signature: "m m m" },
	DeclareMathSizes: { signature: "m m m m" },
	newgathered: { signature: "m m m m" },
	renewgathered: { signature: "m m m m" },
	splitfrac: { signature: "m m" },
	splitdfrac: { signature: "m m" },
	xmathstrut: { signature: "o m" },
	newtheorem: {
		signature: "s m o m o",
		renderInfo: { breakAround: true }
	},
	theoremstyle: {
		signature: "m",
		renderInfo: { breakAround: true }
	},
	newtheoremstyle: {
		signature: "m m m m m m m m m",
		renderInfo: { breakAround: true }
	},
	text: {
		signature: "m",
		renderInfo: { inMathMode: false }
	},
	mathbb: { signature: "m" },
	mathscr: { signature: "m" },
	mathfrak: { signature: "m" },
	frak: { signature: "m" },
	Bdd: { signature: "m" },
	bold: { signature: "m" },
	operatorname: { signature: "s m" },
	DeclareMathOperator: {
		signature: "s m m",
		renderInfo: { breakAround: true }
	},
	eqref: { signature: "m" }
};
var environments = {
	crampedsubarray: {
		signature: "m",
		renderInfo: {
			alignContent: true,
			inMathMode: true
		}
	},
	matrix: { renderInfo: {
		alignContent: true,
		inMathMode: true
	} },
	bmatrix: { renderInfo: {
		alignContent: true,
		inMathMode: true
	} },
	pmatrix: { renderInfo: {
		alignContent: true,
		inMathMode: true
	} },
	vmatrix: { renderInfo: {
		alignContent: true,
		inMathMode: true
	} },
	Bmatrix: { renderInfo: {
		alignContent: true,
		inMathMode: true
	} },
	Vmatrix: { renderInfo: {
		alignContent: true,
		inMathMode: true
	} },
	smallmatrix: { renderInfo: {
		alignContent: true,
		inMathMode: true
	} },
	psmallmatrix: { renderInfo: {
		alignContent: true,
		inMathMode: true
	} },
	vsmallmatrix: { renderInfo: {
		alignContent: true,
		inMathMode: true
	} },
	bsmallmatrix: { renderInfo: {
		alignContent: true,
		inMathMode: true
	} },
	Bsmallmatrix: { renderInfo: {
		alignContent: true,
		inMathMode: true
	} },
	Vsmallmatrix: { renderInfo: {
		alignContent: true,
		inMathMode: true
	} },
	"matrix*": {
		signature: "o",
		renderInfo: {
			alignContent: true,
			inMathMode: true
		}
	},
	"bmatrix*": {
		signature: "o",
		renderInfo: {
			alignContent: true,
			inMathMode: true
		}
	},
	"pmatrix*": {
		signature: "o",
		renderInfo: {
			alignContent: true,
			inMathMode: true
		}
	},
	"vmatrix*": {
		signature: "o",
		renderInfo: {
			alignContent: true,
			inMathMode: true
		}
	},
	"Bmatrix*": {
		signature: "o",
		renderInfo: {
			alignContent: true,
			inMathMode: true
		}
	},
	"Vmatrix*": {
		signature: "o",
		renderInfo: {
			alignContent: true,
			inMathMode: true
		}
	},
	"smallmatrix*": {
		signature: "o",
		renderInfo: {
			alignContent: true,
			inMathMode: true
		}
	},
	"psmallmatrix*": {
		signature: "o",
		renderInfo: {
			alignContent: true,
			inMathMode: true
		}
	},
	"bsmallmatrix*": {
		signature: "o",
		renderInfo: {
			alignContent: true,
			inMathMode: true
		}
	},
	"vsmallmatrix*": {
		signature: "o",
		renderInfo: {
			alignContent: true,
			inMathMode: true
		}
	},
	"Bsmallmatrix*": {
		signature: "o",
		renderInfo: {
			alignContent: true,
			inMathMode: true
		}
	},
	"Vsmallmatrix*": {
		signature: "o",
		renderInfo: {
			alignContent: true,
			inMathMode: true
		}
	},
	multilined: {
		signature: "o o",
		renderInfo: { inMathMode: true }
	},
	cases: { renderInfo: {
		alignContent: true,
		inMathMode: true
	} },
	"cases*": { renderInfo: {
		alignContent: true,
		inMathMode: true
	} },
	dcases: { renderInfo: {
		alignContent: true,
		inMathMode: true
	} },
	"dcases*": { renderInfo: {
		alignContent: true,
		inMathMode: true
	} },
	rcases: { renderInfo: {
		alignContent: true,
		inMathMode: true
	} },
	"rcases*": { renderInfo: {
		alignContent: true,
		inMathMode: true
	} },
	drcases: { renderInfo: {
		alignContent: true,
		inMathMode: true
	} },
	"drcases*": { renderInfo: {
		alignContent: true,
		inMathMode: true
	} },
	spreadlines: {
		signature: "m",
		renderInfo: { inMathMode: true }
	},
	lgathered: {
		signature: "o",
		renderInfo: { inMathMode: true }
	},
	rgathered: {
		signature: "o",
		renderInfo: { inMathMode: true }
	},
	"align*": { renderInfo: {
		inMathMode: true,
		alignContent: true
	} },
	align: { renderInfo: {
		inMathMode: true,
		alignContent: true
	} },
	aligned: { renderInfo: {
		inMathMode: true,
		alignContent: true
	} },
	"alignat*": { renderInfo: {
		inMathMode: true,
		alignContent: true
	} },
	alignat: { renderInfo: {
		inMathMode: true,
		alignContent: true
	} },
	"equation*": { renderInfo: { inMathMode: true } },
	equation: { renderInfo: { inMathMode: true } },
	"gather*": { renderInfo: { inMathMode: true } },
	gather: { renderInfo: { inMathMode: true } },
	"multline*": { renderInfo: { inMathMode: true } },
	multline: { renderInfo: { inMathMode: true } },
	"flalign*": { renderInfo: {
		inMathMode: true,
		alignContent: true
	} },
	flalign: { renderInfo: {
		inMathMode: true,
		alignContent: true
	} },
	split: { renderInfo: { inMathMode: true } },
	displaymath: { renderInfo: { inMathMode: true } },
	theorem: { signature: "o" },
	lemma: { signature: "o" },
	definition: { signature: "o" },
	proposition: { signature: "o" },
	corollary: { signature: "o" },
	remark: { signature: "!o" },
	example: { signature: "!o" },
	proof: { signature: "o" }
};
//#endregion
export { environments, macros };

//# sourceMappingURL=index.js.map